import type { KcContext } from 'keycloakify/login/KcContext';

export const useFieldMessage = (fields: string[], kcContext: KcContext.Common): string => {
    const messages = fields.map((f) => {
        if (kcContext?.messagesPerField.exists(f)) {
            return kcContext.messagesPerField.get(f);
        }
        return '';
    });

    return messages
        .filter((v) => v)
        .join(' ')
        .trim();
};
